<template>
  <div class="examine-fail">
    <p class="fail-info">
      查询到有历史缴费记录，如果您已支付完成且未申请退款，请勿重新支付造成重复扣款
    </p>
    <p>
    <el-button class="sure" @click='$emit("handleClickPaid", "")'>已支付</el-button>
    <el-button class="sure" @click='$emit("handleClickNewPay", "")'>发起新订单</el-button>
    </p>
  </div>
</template>

<script>
  export default {
    name: "existPay",
  }
</script>

<style lang="scss" scoped>
  .examine-fail {
    width: 100%;
    text-align: center;    

    .fail-info {
      line-height: 24px;
      color: #fff;
    }

    .sure {
      width: 100%;
      margin-top: 30px;
      border: none;
      color: var(--main-color);      
    }
  }
</style>
